module.exports = __webpack_public_path__ + "img/jo2.f25dcb9d.png";